import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import useSWR from "swr";
import { isSignedOut, signInPathFor } from "../domain/signInRedirect";
import fetcher from "../hooks/fetcher";
import { IDENTITY_KEY } from "../hooks/identityKey";

export default function SignInRedirect() {
  const history = useHistory();
  const location = useLocation();
  const identity = useSWR(IDENTITY_KEY, fetcher);
  const signedOut = isSignedOut(identity);

  React.useEffect(() => {
    if (signedOut) history.replace(signInPathFor(location));
  }, [signedOut, location, history]);

  return null;
}

SignInRedirect.propTypes = {};
